import {
  CAlert,
  CButton,
  CCol,
  CDatePicker,
  CForm,
  CFormFeedback,
  CFormLabel,
  CFormSelect,
  CLoadingButton,
  CTimePicker,
} from '@coreui/react-pro'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FixtureService from 'src/service/FixtureService'
import TeamService from 'src/service/TeamService'
import ToastComponent from 'src/components/common/TaostComponent'
import CIcon from '@coreui/icons-react'
import { cilPlus, cilTrash } from '@coreui/icons'
import { Link } from 'react-router-dom'

const AddFormForLeagueIndoorFixture = (props) => {
  const [loader, setLoader] = useState(false)
  const [matchTypeList, setMatchTypeList] = useState()
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [teamList, setTeamList] = useState([])
  const [errorMessages, setErrorMessages] = useState([])
  let validationSchema = Yup.object().shape({
    match_type: Yup.string().required('Match type is required'),
    start_date: Yup.string().required('Start date is required'),
    end_date: Yup.string().required('End date is required'),
    start_time: Yup.string().required('Start time is required'),
    end_time: Yup.string().required('End time is required'),
  })

  useEffect(() => {
    setLoader(true)
    TeamService.getTeamListByGrade().then((res) => {
      if (res.status === 200) {
        setLoader(false)
        setTeamList(res.data)
        setMatchTypeList(res.matchTypeList)
      }
    })
  }, [props.visibleHorizontal])

  // Validation for dynamic rows
  const [teamRowsError, setTeamRowsError] = useState([])
  //validation logic can be ended here
  const formik = useFormik({
    initialValues: {
      match_type: '',
      start_date: '',
      end_date: '',
      start_time: '',
      end_time: '',
      opposition_club: '',
      vanue: '',
      teamRows: [{ home: '', away: '' }], // NEW FIELD
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data, actions) => {
      const rowErrors = []

      teamRows.forEach((row, index) => {
        const err = {}
        if (!row.home) err.home = 'Home team is required'
        if (!row.away) err.away = 'Away team is required'
        if (row.home && row.away && row.home === row.away) err.same = 'Home and Away cannot be same'

        rowErrors[index] = err
      })

      setTeamRowsError(rowErrors)

      // ❗ STOP submit if any error exists
      const hasErrors = rowErrors.some((e) => Object.keys(e).length > 0)
      if (hasErrors) {
        setLoader(false)
        return
      }

      data.teamRows = teamRows // Send dynamic rows to backend
      data.start_date = startDate
      data.end_date = endDate
      data.start_time = lockoutStartTime
      data.end_time = lockoutEndTime
      setLoader(true)
      FixtureService.saveFixtureForLeagueAndIndoor(data).then((res) => {
        if (res.success) {
          setErrorMessages([])
          props.fetchData(
            props.activePage,
            props.columnFilter,
            props.columnSorter,
            props.itemsPerPage,
          )
          ToastComponent(res.message, 'success')
          setLoader(false)
        } else {
          const errors =
            res.errors && Array.isArray(res.errors)
              ? res.errors
              : [res.message || 'Something went wrong.']
          setErrorMessages(errors) // Update error messages
          setLoader(false)
        }
      })
    },
  })
  const handleStartDate = (event) => {
    setMinEndDate(event)
    const dateFormat = moment(event).format('YYYY-MM-DD')
    setStartDate(dateFormat)
    setEndDate('')
  }
  const handleEndDate = (event) => {
    const dateFormat = moment(event).format('YYYY-MM-DD')
    setEndDate(dateFormat)
  }

  const [minEndDate, setMinEndDate] = useState(new Date())
  const todayDate = new Date()
  const lastDate = minEndDate
  const minDate = todayDate.setDate(todayDate.getDate() - 1)
  const minasdasDate = lastDate.setDate(lastDate.getDate())

  const [lockoutStartTime, setLockoutStartTime] = useState('')
  const [lockoutEndTime, setLockoutEndTime] = useState('')
  const handleLockoutStartTime = (event) => {
    const dateFormat = moment(event, ['H:mm']).format('HH:mm')
    setLockoutStartTime(dateFormat)
  }
  const handleLockoutEndTime = (event) => {
    const dateFormat = moment(event, ['H:mm']).format('HH:mm')
    setLockoutEndTime(dateFormat)
  }
  // Add more functonality logic starts here
  const [teamRows, setTeamRows] = useState([{ home: '', away: '' }])
  const addRow = () => {
    setTeamRows([...teamRows, { home: '', away: '' }])
  }

  const deleteRow = (index) => {
    const updated = [...teamRows]
    updated.splice(index, 1)
    setTeamRows(updated)
  }
  const handleTeamChange = (index, field, value) => {
    const updated = [...teamRows]
    updated[index][field] = value
    setTeamRows(updated)
  }

  // Add more functonality logic finish here
  return (
    <>
      {errorMessages.length > 0 && (
        <div className="error-list">
          {errorMessages.map((error, index) => (
            <>
              {/* <li key={index}>{error}</li> */}
              <CAlert color="danger" key={index}>
                {error}
              </CAlert>
            </>
          ))}
        </div>
      )}
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CCol md={4}>
          <CFormLabel className="fw-bold" htmlFor="team">
            Match Type *
          </CFormLabel>
          <CFormSelect
            aria-label="Select Match Type"
            name="match_type"
            className={
              'form-control' +
              (formik.errors.match_type && formik.touched.match_type ? ' is-invalid' : '')
            }
            defaultValue={formik.values.match_type}
            onChange={formik.handleChange}
            id="match_type"
          >
            <option value={0}>Select Match Type</option>
            {matchTypeList &&
              matchTypeList.map((item, key) => (
                <option value={item?.id} key={key}>
                  {item?.name}
                </option>
              ))}
          </CFormSelect>
          {formik.errors.match_type && formik.touched.match_type && (
            <CFormFeedback invalid>{formik.errors.match_type}</CFormFeedback>
          )}
        </CCol>
        <CCol md={4}>
          <CFormLabel className="fw-bold" htmlFor="Start Date">
            Start Date *
          </CFormLabel>
          <CDatePicker
            date={startDate}
            defaultValue={startDate}
            className={formik.errors.start_date && formik.touched.start_date ? 'is-invalid' : ''}
            locale="en-US"
            name="start_date"
            placeholder={'Start Date'}
            onDateChange={(e) => {
              handleStartDate(e)
              formik.setTouched({
                ...formik.touched,
                start_date: true,
              })
              formik.setFieldValue('start_date', moment(e).format('YYYY-MM-DD'))
            }}
            format={'dd/MM/yyyy'}
            // minDate={todayDate}
            cleaner={false}
          />

          {formik.errors.start_date && formik.touched.start_date && (
            <CFormFeedback invalid>{formik.errors.start_date}</CFormFeedback>
          )}
        </CCol>
        <CCol md={4}>
          <CFormLabel className="fw-bold" htmlFor="End Date">
            End Date *
          </CFormLabel>
          <CDatePicker
            date={endDate}
            defaultValue={endDate}
            className={formik.errors.end_date && formik.touched.end_date ? 'is-invalid' : ''}
            locale="en-US"
            name="end_date"
            placeholder={'End Date'}
            // onDateChange={handleEndDate}
            onDateChange={(e) => {
              handleEndDate(e)
              formik.setTouched({
                ...formik.touched,
                end_date: true,
              })
              formik.setFieldValue('end_date', moment(e).format('YYYY-MM-DD'))
            }}
            format={'dd/MM/yyyy'}
            cleaner={false}
            // minDate={minEndDate}
          />

          {formik.errors.end_date && formik.touched.end_date && (
            <CFormFeedback invalid>{formik.errors.end_date}</CFormFeedback>
          )}
        </CCol>
        <CCol md={4}>
          <CFormLabel className="fw-bold" htmlFor="start_time">
            Start Time *
          </CFormLabel>
          <CTimePicker
            locale="en-US"
            value={lockoutStartTime}
            seconds={false}
            // onTimeChange={handleLockoutStartTime}
            className={formik.errors.start_time && formik.touched.start_time ? 'is-invalid' : ''}
            onTimeChange={(e) => {
              handleLockoutStartTime(e)
              formik.setTouched({
                ...formik.touched,
                start_time: true,
              })
              formik.setFieldValue('start_time', moment(e).format('YYYY-MM-DD'))
            }}
            // ampm={false}
          />

          {formik.errors.start_time && formik.touched.start_time && (
            <CFormFeedback invalid>{formik.errors.start_time}</CFormFeedback>
          )}
        </CCol>
        <CCol md={4}>
          <CFormLabel className="fw-bold" htmlFor="endTime">
            End Time *
          </CFormLabel>
          <CTimePicker
            className={formik.errors.end_time && formik.touched.end_time ? 'is-invalid' : ''}
            locale="en-US"
            value={lockoutEndTime}
            seconds={false}
            onTimeChange={(e) => {
              handleLockoutEndTime(e)
              formik.setTouched({
                ...formik.touched,
                end_time: true,
              })
              formik.setFieldValue('end_time', moment(e).format('YYYY-MM-DD'))
            }}
            // ampm={false}
          />

          {formik.errors.end_time && formik.touched.end_time && (
            <CFormFeedback invalid>{formik.errors.end_time}</CFormFeedback>
          )}
        </CCol>
        <CCol md={4}>
          <CFormLabel className="fw-bold" htmlFor="alast_name">
            Venue
          </CFormLabel>
          <input
            type="text"
            name="vanue"
            className={
              'form-control' + (formik.errors.vanue && formik.touched.vanue ? ' is-invalid' : '')
            }
            id="vanue"
            placeholder="Venue"
            defaultValue={formik.values.vanue}
            onChange={formik.handleChange}
          />
          {formik.errors.vanue && formik.touched.vanue && (
            <CFormFeedback invalid>{formik.errors.vanue}</CFormFeedback>
          )}
        </CCol>

        <div className="">
          {/* Add More section will apper here */}
          {teamRows.map((row, index) => (
            <div className="row mb-3 team-row" key={index}>
              <CCol md={5} className="form-col">
                <CFormLabel className="fw-bold">Home Team</CFormLabel>
                <CFormSelect
                  value={row.home}
                  onChange={(e) => handleTeamChange(index, 'home', e.target.value)}
                  className={teamRowsError[index]?.home ? 'is-invalid' : ''}
                >
                  <option value="">Select Home Team</option>
                  {teamList?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.name} ({item.sn})
                    </option>
                  ))}
                </CFormSelect>
                {teamRowsError[index]?.home && (
                  <div className="invalid-feedback d-block">{teamRowsError[index].home}</div>
                )}
              </CCol>

              <CCol md={5} className="form-col">
                <CFormLabel className="fw-bold">Away Team</CFormLabel>
                <CFormSelect
                  value={row.away}
                  onChange={(e) => handleTeamChange(index, 'away', e.target.value)}
                  className={
                    teamRowsError[index]?.away || teamRowsError[index]?.same ? 'is-invalid' : ''
                  }
                >
                  <option value="">Select Away Team</option>
                  {teamList?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.name} ({item.sn})
                    </option>
                  ))}
                </CFormSelect>
                {teamRowsError[index]?.away && (
                  <div className="invalid-feedback d-block">{teamRowsError[index].away}</div>
                )}
                {teamRowsError[index]?.same && (
                  <div className="invalid-feedback d-block">{teamRowsError[index].same}</div>
                )}
              </CCol>

              <CCol md={2} className="d-flex align-items-end justify-content-start button-col">
                {index === 0 ? (
                  <CButton color="success" onClick={addRow}>
                    <CIcon icon={cilPlus} className="me-1" /> Add
                  </CButton>
                ) : (
                  <CButton color="danger" onClick={() => deleteRow(index)}>
                    <CIcon icon={cilTrash} className="me-1" /> Delete
                  </CButton>
                )}
                {teamRowsError[index]?.home && <div className="invalid-feedback">&nbsp;</div>}
              </CCol>
            </div>
          ))}
        </div>

        {/* Will finish here */}

        <CCol md={6}>
          <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
            Submit
          </CLoadingButton>
          &nbsp;&nbsp;
          <CButton color="primary" variant="outline" component={Link} to="/fixture-import">
            Import
          </CButton>
        </CCol>
      </CForm>
    </>
  )
}

export default AddFormForLeagueIndoorFixture
